export default {
  ZH_HK: {
    GenMeet: "生成Meet",
    themeContent: "討論主題內容",
    add: "添加",
    QuestionRequired: "請輸入"
  },
  zh_cn: {
    GenMeet: "生成Meet",
    themeContent: "讨论主题内容",
    add: "添加",
    QuestionRequired: "请输入"
  },
  EN: {
    GenMeet: "Generate Meet",
    themeContent: "Topics",
    add: "Add",
    QuestionRequired: "Please enter"
  },
  es: {
    GenMeet: "Generar Meet",
    themeContent: "Contenido de Tema de Discusión",
    add: "Añadir",
    QuestionRequired: "Por favor ingrese"
  }
};
